export type SectionsCatalogViewMode = "browse" | "list";

export const SECTIONS_CATALOG_VIEW_OPTIONS = [
  { label: "Browse", value: "browse" as const },
  { label: "List", value: "list" as const }
];
